exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.cancelPareDialog .orderNo{color:#409EFF\n}\n.cancelPareDialog .el-dialog__title{font-size:14px !important;font-weight:bold\n}\n.cancelPareDialog .el-dialog__body{text-align:center\n}\n", "", {"version":3,"sources":["/data/jenkins/workspace/shop/src/components/order/cancelPare-dialog.vue"],"names":[],"mappings":";AAuCA,2BAEI,aAAa;CAFjB;AAAA,oCAKI,0BACA,gBAAiB;CANrB;AAAA,mCASI,iBAAkB;CACnB","file":"cancelPare-dialog.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.cancelPareDialog {\n  .orderNo {\n    color:#409EFF;\n  }\n  .el-dialog__title {\n    font-size: 14px !important;\n    font-weight: bold;\n  }\n  .el-dialog__body {\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6d86c716","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/order/cancelPare-dialog.vue
// module id = wyyp
// module chunks = 2